import React, { useState, useRef } from 'react';
import { Stepper } from '@progress/kendo-react-layout';
import ModuleAppBar from '../modules/module_appbar';
import ModuleStep1 from '../modules/module_step1';
import ModuleStep2 from '../modules/module_step2';
import ModuleStep3 from '../modules/module_step3';
import ModuleStep4 from '../modules/module_step4';
import ModuleStep5 from '../modules/module_step5';
import ModuleStep6 from '../modules/module_step6';

const ConstructionDiary: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const step2Ref = useRef<{ saveAll: () => Promise<void> }>(null);

  const steps = [
    { label: 'Step 1' },
    { label: 'Step 2' },
    { label: 'Step 3' },
    { label: 'Step 4' },
    { label: 'Step 5' },
    { label: 'Step 6' },
  ];

  const handleStepChange = async (e: any) => {
    // Falls wir gerade in Step 2 (ModuleStep2) sind und den Step verlassen,
    // rufen wir zuerst die saveAll-Methode auf.
    if (currentStep === 1 && step2Ref.current) {
      await step2Ref.current.saveAll();
    }
    setCurrentStep(e.value);
  };

  return (
    <div style={{ padding: '10px' }}>
      <ModuleAppBar />
      <Stepper
        style={{ marginTop: '40px'}}
        items={steps}
        value={currentStep}
        onChange={handleStepChange}
        className="custom-stepper"
      />
      <div style={{ marginTop: '40px'}}>
        {currentStep === 0 && <ModuleStep1 />}
        {currentStep === 1 && <ModuleStep2 ref={step2Ref} />}
        {currentStep === 2 && <ModuleStep3 />}
        {currentStep === 3 && <ModuleStep4 />}
        {currentStep === 4 && <ModuleStep5 />}
        {currentStep === 5 && <ModuleStep6 />}
      </div>
    </div>
  );
};

export default ConstructionDiary;
